export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/YE-0992c8ca7b8df173f100a619226a3ccc.png";